import { CheckCircle, XCircle, Clock, AlertTriangle, CalendarOff, Bell } from 'lucide-react';

const STATUS_CONFIG = {
  active: { label: 'Actif', bg: 'bg-green-100', text: 'text-green-800', icon: CheckCircle },
  inactive: { label: 'Inactif', bg: 'bg-gray-100', text: 'text-gray-800', icon: XCircle },
  pending: { label: 'En attente', bg: 'bg-yellow-100', text: 'text-yellow-800', icon: Clock },
  'on-leave': { label: 'En congé', bg: 'bg-yellow-100', text: 'text-yellow-800', icon: Clock },
  maintenance: { label: 'Maintenance', bg: 'bg-yellow-100', text: 'text-yellow-800', icon: AlertTriangle },
  out_of_service: { label: 'Hors service', bg: 'bg-red-100', text: 'text-red-800', icon: XCircle },
  // Demandes parents (parent_requests / absences — frontRequests.jsx)
  approved: { label: 'Approuvée', bg: 'bg-green-100', text: 'text-green-800', icon: CheckCircle },
  rejected: { label: 'Refusée', bg: 'bg-red-100', text: 'text-red-800', icon: XCircle },
  // Absence auto-validée : pas de workflow pending/approved/rejected réel,
  // "Déclarée" évite de laisser croire à un examen en cours (status DB reste
  // 'pending' pour toujours) — voir même choix côté app parent.
  declared: { label: 'Déclarée', bg: 'bg-gray-100', text: 'text-gray-800', icon: CalendarOff },
  // Incidents chauffeur (incidents.status — frontIncidents.jsx)
  open: { label: 'Ouvert', bg: 'bg-red-100', text: 'text-red-800', icon: AlertTriangle },
  acknowledged: { label: 'Pris en compte', bg: 'bg-blue-100', text: 'text-blue-800', icon: Clock },
  resolved: { label: 'Résolu', bg: 'bg-green-100', text: 'text-green-800', icon: CheckCircle },
  // Notifications admin — statut de lecture (frontNotifications.jsx)
  read: { label: 'Lue', bg: 'bg-gray-100', text: 'text-gray-600', icon: CheckCircle },
  unread: { label: 'Non lue', bg: 'bg-blue-100', text: 'text-blue-800', icon: Bell },
};

export const StatusBadge = ({ status, label, className }) => {
  const key = status?.toLowerCase() ?? 'inactive';
  const config = STATUS_CONFIG[key] ?? STATUS_CONFIG.inactive;
  const Icon = config.icon;
  const colorClass = className ?? `${config.bg} ${config.text}`;

  return (
    <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium ${colorClass}`}>
      <Icon className="w-3 h-3" />
      {label ?? config.label}
    </span>
  );
};

export default StatusBadge;
